/*
 * A product can be moved to another machine when it is a virtual appliance with a key: the key, licenses and
 * maintenance follow the new VM's serial. A hardware appliance's serial is edited in its form instead (SYN-3453).
 */
export const canMoveProduct = (product, productModels) => {
	if (!product?.id || !product.activationCode) {
		return false;
	}

	const model = (productModels || []).find((productModel) => { return productModel.id === product.modelId; });

	return !!model?.virtualAppliance;
};

export default { canMoveProduct };
